import { isV2PermissionsEnabled } from '../../../helpers/featureFlags/isV2PermissionsEnabled';

export const ALLOWED_REGIONS = {
  NAM: ['US', 'CA'],
  LATAM: [
    'AR',
    'BO',
    'BR',
    'CL',
    'CO',
    'CR',
    'CU',
    'DO',
    'EC',
    'GT',
    'HN',
    'MX',
    'NI',
    'PA',
    'PE',
    'PY',
    'PR',
    'SV',
    'UY',
    'VE',
    'BS',
    'BB',
    'GD',
    'LC',
    'VC',
    'AG',
    'KN',
    'DM',
    'HT',
    'JM',
    'TT',
  ],
  APAC: [
    'AF',
    'AS',
    'AU',
    'BD',
    'BN',
    'CC',
    'CK',
    'CN',
    'CX',
    'FJ',
    'FM',
    'GU',
    'HK',
    'ID',
    'IN',
    'IO',
    'JP',
    'KH',
    'KI',
    'KP',
    'KR',
    'LA',
    'LK',
    'MH',
    'MM',
    'MN',
    'MO',
    'MP',
    'MV',
    'MY',
    'NC',
    'NF',
    'NP',
    'NR',
    'NU',
    'NZ',
    'PF',
    'PG',
    'PH',
    'PK',
    'PW',
    'SB',
    'SG',
    'TH',
    'TL',
    'TO',
    'TV',
    'TW',
    'VN',
    'VU',
    'WF',
    'WS',
  ],
  EMEA: [
    'AE',
    'AL',
    'AM',
    'AO',
    'AT',
    'AZ',
    'BA',
    'BE',
    'BF',
    'BG',
    'BI',
    'BJ',
    'BW',
    'BY',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CM',
    'CV',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DZ',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FR',
    'GA',
    'GB',
    'GE',
    'GH',
    'GM',
    'GN',
    'GQ',
    'GR',
    'HR',
    'HU',
    'IE',
    'IL',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JO',
    'KE',
    'KM',
    'KW',
    'LB',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MD',
    'ME',
    'MG',
    'MK',
    'ML',
    'MR',
    'MT',
    'MZ',
    'MU',
    'NA',
    'NE',
    'NG',
    'NL',
    'NO',
    'OM',
    'PL',
    'PS',
    'PT',
    'QA',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SC',
    'SD',
    'SE',
    'SI',
    'SK',
    'SL',
    'SN',
    'SO',
    'SS',
    'ST',
    'SY',
    'SZ',
    'TD',
    'TG',
    'TN',
    'TR',
    'TZ',
    'UA',
    'UG',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ],
};

export const DEFAULT_REGIONS = [
  { name: 'APAC', region: 'APAC' },
  { name: 'NAM (US & Canada)', region: 'NAM' },
  { name: 'EMEA', region: 'EMEA' },
  { name: 'LATAM', region: 'LATAM' },
];

export const DEFAULT_REGIONS_SHORT = ['APAC', 'NAM', 'EMEA', 'LATAM'];

export const getSelectedRegion = (countryAbbr) => {
  return Object.entries(ALLOWED_REGIONS).find(([region, countries]) =>
    countries.includes(countryAbbr),
  )?.[0];
};

export const getSortedRegions = (regions) => {
  if (!isV2PermissionsEnabled()) return DEFAULT_REGIONS;

  return [
    { name: 'APAC', region: 'APAC' },
    { name: 'NAM (US & Canada)', region: 'NAM' },
    { name: 'EMEA', region: 'EMEA' },
    { name: 'LATAM', region: 'LATAM' },
  ].filter((item) => regions.includes(item.region));
};
